module.exports = __webpack_public_path__ + "static/media/mobile-footer.6fc2b929.svg";